import React, { useMemo } from 'react'
import injectStyles from 'react-jss'
import moment from 'moment'
import { StatusLabel } from '../../../../../../Components/StatusLabel'
import SimpleTableTable from '../../../../../../Components/SimpleTableTable'
import { LinkEdit } from '../../../../../../Components/Link/Edit'
import { ButtonDeleteInline } from '../../../../../../Components/Buttons/ButtonDeleteInline'
import { styles } from './style'
import { getActivityTableData, TableHeader } from './utils'
import { LinkView } from '../../../../../../Components/Link/View'

const ActivityTable = ({ spyActivities, deleteMission, ...props }) => {
  const data = useMemo(() => getActivityTableData(spyActivities), [
    spyActivities,
  ])

  const editMissionLink = mission => `/dashboard/mission/${mission.id}/edit`
  const viewMissionLink = mission => `/dashboard/mission/${mission.id}`

  const postRowRender = spyActivity => {
    return {
      ...spyActivity,
      'WEEK': <div style={{ 'paddingLeft': '30px' }}>{spyActivity.WEEK}</div>,
      'STATUS': (
        <StatusLabel status={spyActivity.STATUS}>
          {spyActivity.STATUS}
        </StatusLabel>
      ),
      'ACTIONS': (
        <div className={props.classes.actions}>
          <LinkView to={viewMissionLink(spyActivity)} />
          <LinkEdit to={editMissionLink(spyActivity)} />
          <ButtonDeleteInline
            onClickHandler={() => deleteMission(spyActivity)}
          />
        </div>
      ),
    }
  }

  const onSortDate = (a, b) => {
    // if a or b is not the right string its sorting it as the lowest date
    if (typeof a !== 'string' || !a.match(/\d{2}\/\d{2}\/\d{4}/)) {
      return 1
    }
    if (typeof b !== 'string' || !b.match(/\d{2}\/\d{2}\/\d{4}/)) {
      return -1
    }

    return moment(b, 'DD/MM/YYYY') - moment(a, 'DD/MM/YYYY')
  }

  return (
    <div className={props.classes.wrapper}>
      <SimpleTableTable
        header={TableHeader}
        data={data}
        postRowRender={postRowRender}
        showPages={false}
        sortOn={[
          'CLIENT',
          { label: 'DATE', sort: onSortDate },
          'WEEK',
          'TIME',
          'LOCATION',
          'NAME',
          'STATUS',
        ]}
        cypress_id={'activitiesTable'}
      />
    </div>
  )
}

export default injectStyles(styles)(ActivityTable)
